export default function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return !!getIn(nonNullGetFormState(state), form + ".submitting");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/isSubmitting.js
// module id = 2148
// module chunks = 1